import classnames from 'classnames'
import React from 'react'
import { FlagIcon } from 'src/components/framework/icons/flag'

import * as styles from './result.module.scss'
import { SearchItem } from './search-item.dto'

interface Props {
  result: SearchItem
  selected: boolean
}

export const Result: React.FC<Props> = ({
  result: { name, image, type, region, ticker, permalink },
  selected,
}) => (
  <div role="listitem">
    <a href={`/${permalink}`}>
      <div
        className={classnames(styles.result, {
          [styles.resultSelected]: selected,
        })}
      >
        <img
          className={styles.result__image}
          src={
            !!image
              ? `https://images.stockopedia.com/security_images/${image}`
              : `https://app.stockopedia.com/assets/app/images/${type}.png`
          }
        />

        <div className={styles.resultContent}>
          <span className={styles.resultContent__title}>{name}</span>

          <div className={styles.resultContent__details}>
            <FlagIcon country={region} />
            <span className={styles.resultContent__ticker}>{ticker}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
)
